module.exports = __webpack_public_path__ + "static/media/page09_front.e5824ba4.gif";